import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { Profile } from '../../../models/profile.model';
import { TextFieldComponent } from '../../text-field/text-field.component';
import { TranslatePipe } from '@ngx-translate/core';
import {
  MainInfoForm,
  FormGroupTyped,
} from '../../../../core/types/interfaces';

@Component({
  selector: 'app-main-info',
  templateUrl: './main-info.component.html',
  styleUrls: ['./main-info.component.scss'],
  imports: [TextFieldComponent, TranslatePipe],
})
export class MainInfoComponent {
  @Input() profile: Profile;
  @Input() formGroup: FormGroupTyped<MainInfoForm>;

  constructor() {}
}
